import styled from 'styled-components';
import { IconButton } from '@chegg-ui/button';
import { Textarea as CheggUiTextArea } from '../Shared/TextArea';
export var Wrapper = styled.div.withConfig({
  componentId: "nxdwig-0"
})(["display:flex;align-items:flex-start;"]);
export var TextArea = styled(CheggUiTextArea).withConfig({
  componentId: "nxdwig-1"
})(["display:inline-block;flex:1;height:5rem;textarea{resize:vertical;min-height:5rem;}"]);
export var DeleteAnnotationButton = styled(IconButton).withConfig({
  componentId: "nxdwig-2"
})(["margin:26px 0px 0px 10px;padding:0px;"]);